import React from 'react';
import Translate from 'components/Common/translate';
import classes from 'styles/Common/loginButton.module.scss';
import icons from 'styles/customFont.module.css';

class LoginButton extends React.Component {
  handleClick() {
    window.location.href = process.env.REACT_APP_LOGIN_SERVICE_URL + encodeURIComponent(window.location.href);
  }

  render() {
    return (
      <div className={classes.container}>
        {/*  eslint-disable-next-line */}
        <a href="#" onClick={this.handleClick}>
          <i className={icons.iconContactProfile} />
          <Translate id={'signIn'} />
        </a>
      </div>
    );
  }
}

export default LoginButton;
